import {
  Button,
  LoadingSpinner,
  useModal,
  AnnotateSVG,
} from "@newsela/angelou";
import { isEmpty } from "@s-libs/micro-dash";
import PropTypes from "prop-types";

import usePrincipalGet from "@/principal/hooks/usePrincipalGet";
import { useSchoolGet } from "@/school/hooks/useSchoolDetailsGet";
import ChangeSchoolModal from "@/teacher/ChangeSchoolModal";
import {
  changeSchoolButtonCss,
  containerCss,
  schoolListCss,
} from "./TeacherSchoolProfile.style";

const propTypes = {
  user: PropTypes.shape({
    schools: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
      }),
    ).isRequired,
    principal: PropTypes.shape({
      id: PropTypes.number,
    }),
  }).isRequired,
  teacher: PropTypes.shape({
    _editable: PropTypes.shape({
      school: PropTypes.bool,
    }).isRequired,
  }).isRequired,
};

const TeacherSchoolProfile = ({ user, teacher }) => {
  const [modalProps, setActive, triggerRef] = useModal(false);
  const id = user?.schools[0]?.id;
  const { data: school, loading: isLoadingSchool } = useSchoolGet(id, {
    include_district: true,
  });
  const { data: principal, loading: isLoadingPrincipal } = usePrincipalGet(
    user.principal?.id,
  );
  const isEditable = teacher._editable.school && !principal;
  const isLoading = isLoadingSchool || isLoadingPrincipal;

  if (isLoading) {
    return (
      <div css={containerCss}>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div css={containerCss}>
      <h4>My school as a Teacher</h4>
      <ul role="list" css={schoolListCss}>
        <li>
          <strong>Name:</strong> {school?.name}
        </li>
        {!isEmpty(school?.address) && (
          <li>
            <strong>School address:</strong>
            <p>{school?.address?.address1}</p>
            <p>
              {school?.address?.city}, {school?.address?.state}
            </p>
            <p>{school?.address?.zip_code}</p>
          </li>
        )}
        {!isEmpty(school?.district) && (
          <li>
            <strong>District:</strong>{" "}
            {school?.district.map((district) => district.name).join(", ")}
          </li>
        )}
      </ul>
      {isEditable && (
        <>
          <Button
            flavor={Button.flavors.tertiary}
            size={Button.sizes.sm}
            icon={{
              SvgComponent: AnnotateSVG,
              alignment: Button.iconAlignments.left,
            }}
            ref={triggerRef}
            __cssFor={changeSchoolButtonCss}
            onClick={() => setActive(true)}
          >
            Change school
          </Button>
          <ChangeSchoolModal
            user={user}
            modalProps={modalProps}
            setActive={setActive}
          />
        </>
      )}
    </div>
  );
};

TeacherSchoolProfile.propTypes = propTypes;

export default TeacherSchoolProfile;
